import React from "react";

import { Typography, Grid, Theme, Link as LinkMUI } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { Link } from "react-router-dom";

const useStyles = makeStyles()((theme: Theme) => ({
  menuBar: {
    background: theme.palette.backgrounds.sectionGradient,
    boxShadow: theme.shadow,
    gridArea: "footer",
  },

  itemContainer: {
    flex: 1,
    height: "100%",
    padding: theme.spacing(1),
  },

  iconItem: {
    alignItems: "flex-end",
    display: "inline-grid",
    gridTemplateRows: "70% 30%",
    justifyItems: "center",
    width: "100%",
    height: "100%",

    "& > img": {
      height: "fit-content",
      alignSelf: "center",
    },
  },

  monitoringMiniFix: {
    padding: "0 3px",
  },
}));

export const QuickAccessMenu = () => {
  const { classes } = useStyles();

  return (
    <Grid
      container
      justifyContent="space-around"
      alignItems="center"
      className={classes.menuBar}
    >
      <Grid item container className={classes.itemContainer} direction="column">
        <LinkMUI
          className={classes.iconItem}
          component={Link}
          to="/admin/billing"
          underline="none"
        >
          <img
            src="/static/img/icon-menu-billing.svg"
            alt="Cédula de dinheiro genérica"
          />
          <Typography
            align="center"
            variant="caption"
            fontWeight="medium"
            color="primary.main"
          >
            Economia
          </Typography>
        </LinkMUI>
      </Grid>

      <Grid item container className={classes.itemContainer} direction="column">
        <LinkMUI
          className={classes.iconItem}
          component={Link}
          to="/admin/monitoring"
          underline="none"
        >
          <img
            src="/static/img/icon-menu-monitoring.svg"
            alt="Um monitor de computador"
            className={classes.monitoringMiniFix}
          />
          <Typography
            fontWeight="medium"
            align="center"
            variant="caption"
            color="primary.main"
          >
            Monitore
          </Typography>
        </LinkMUI>
      </Grid>

      <Grid item container className={classes.itemContainer} direction="column">
        <LinkMUI
          className={classes.iconItem}
          component={Link}
          to="/admin/automation"
          underline="none"
        >
          <img
            src="/static/img/icon-menu-automation.svg"
            alt="Smart meter e controle remoto"
          />
          <Typography
            fontWeight="medium"
            align="center"
            variant="caption"
            color="primary.main"
          >
            Automação
          </Typography>
        </LinkMUI>
      </Grid>

      <Grid item container className={classes.itemContainer} direction="column">
        <LinkMUI
          className={classes.iconItem}
          component={Link}
          to="/frames/store"
          underline="none"
        >
          <img
            src="/static/img/icon-menu-store.svg"
            alt="Carrinho de supermercado"
          />
          <Typography
            fontWeight="medium"
            align="center"
            variant="caption"
            color="primary.main"
          >
            Loja
          </Typography>
        </LinkMUI>
      </Grid>

      <Grid item container className={classes.itemContainer} direction="column">
        <LinkMUI
          className={classes.iconItem}
          component={Link}
          to="/admin/decarbonization"
          underline="none"
        >
          <img
            src="/static/img/icon-menu-descarbonize.svg"
            alt="Figura de uma nuvem com a indicação de CO2"
          />
          <Typography
            fontWeight="medium"
            align="center"
            variant="caption"
            color="primary.main"
          >
            CO2e
          </Typography>
        </LinkMUI>
      </Grid>

      <Grid item container className={classes.itemContainer} direction="column">
        <LinkMUI
          className={classes.iconItem}
          component={Link}
          to="/frames/alga-ai"
          underline="none"
        >
          <img
            src="/static/img/icon-menu-alga.svg"
            alt="Alga, a mascote da Enermatch"
          />
          <Typography
            fontWeight="medium"
            align="center"
            variant="caption"
            color="primary.main"
          >
            Alga AI
          </Typography>
        </LinkMUI>
      </Grid>
    </Grid>
  );
};
